import create, { GetState, SetState } from "zustand";

export type NavStoreType = {
    showSignUp: boolean;
    setShowSignUp: (showSignUp: boolean) => void; 
};

export const useNavStore = create<NavStoreType>(
    (set: SetState<NavStoreType>, get: GetState<NavStoreType>) => ({
        showSignUp: true,
        setShowSignUp: (showSignUp: boolean) => {
        set((state) => {
          state.showSignUp = showSignUp;
        });
      }
    })
  );



